function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Input, Form, Button, Select, Alert, Radio, List, Upload, InputNumber, QRCode, Modal, Typography, Switch, Descriptions, message, DatePicker, Divider, Space, Drawer } from 'antd';
import { Container, Row, Col } from "react-bootstrap";
import axios from 'axios';
import Common from "../includes/Common";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Option = Select.Option;
var EditCustomer = function EditCustomer(_ref) {
  var _ref$handleUpdate = _ref.handleUpdate,
    handleUpdate = _ref$handleUpdate === void 0 ? null : _ref$handleUpdate,
    customer = _ref.customer;
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFormLoading = _useState2[0],
    setIsFormLoading = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    errorMessage = _useState4[0],
    setErrorMessage = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    successMessage = _useState6[0],
    setSuccessMessage = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    companyOptions = _useState8[0],
    setCompanyOptions = _useState8[1];
  var _useState9 = useState([]),
    _useState0 = _slicedToArray(_useState9, 2),
    companies = _useState0[0],
    setCompanies = _useState0[1];
  var _useState1 = useState(true),
    _useState10 = _slicedToArray(_useState1, 2),
    companyDisabled = _useState10[0],
    setCompanyDisabled = _useState10[1];
  var _useState11 = useState(true),
    _useState12 = _slicedToArray(_useState11, 2),
    insDisabled = _useState12[0],
    setInsDisabled = _useState12[1];
  var _useState13 = useState(null),
    _useState14 = _slicedToArray(_useState13, 2),
    userCompany = _useState14[0],
    setUserCompany = _useState14[1];
  var _useState15 = useState([]),
    _useState16 = _slicedToArray(_useState15, 2),
    file = _useState16[0],
    setFile = _useState16[1];
  var _useState17 = useState(true),
    _useState18 = _slicedToArray(_useState17, 2),
    uploadDisabled = _useState18[0],
    setUploadDisabled = _useState18[1];
  var _useState19 = useState([]),
    _useState20 = _slicedToArray(_useState19, 2),
    rdata = _useState20[0],
    setRdata = _useState20[1];
  var today = new Date();
  var date = today.getDate() + '/' + (today.getMonth() + 1) + '/' + today.getFullYear();
  var genderOptions = [{
    label: 'Homme',
    value: 'H'
  }, {
    label: 'Femme',
    value: 'F'
  }];
  var categoryOptions = [{
    label: 'Particulier',
    value: 0
  }, {
    label: 'Conventionné',
    value: 1
  }];
  var onCategorieChanged = function onCategorieChanged(e) {
    if (e == 1) {
      form.setFieldsValue({
        insurance_company_id: companyOptions
      });
      setCompanyDisabled(false);
      setInsDisabled(false);
      setUploadDisabled(false);
    } else {
      setCompanyDisabled(true);
      setInsDisabled(true);
      setUploadDisabled(true);
    }
  };
  var onCompanyChanged = function onCompanyChanged(v) {
    setUserCompany(companies.filter(function (c) {
      return c.id == v;
    })[0]);
  };
  var onFinish = function onFinish(values) {
    setRdata([]);
    var formData = new FormData();
    formData.append("id", customer.id);
    formData.append('firstname', values.firstname);
    formData.append('lastname', values.lastname);
    formData.append('job', values.job);
    formData.append('birthdate', values.birthdate);
    formData.append('category', values.category);
    formData.append('mobile', values.mobile);
    formData.append('insnumber', values.insnumber);
    formData.append('company_id', values.company_id);
    formData.append("address", values.address);
    formData.append('gender', values.gender);
    formData.append("user_id", Common.currentUser.id);
    setIsFormLoading(true);
    axios.post(Common.baseApiUrl + 'editcustomer/' + Common.currentUser.id.toString(), formData).then(function (response) {
      setIsFormLoading(false);
      if (response.data.status == 200) {
        handleUpdate();
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setIsFormLoading(false);
      setErrorMessage('Une erreur est survenue');
    });
  };
  useEffect(function () {
    form.setFieldsValue({
      firstname: customer.firstname,
      lastname: customer.lastname,
      gender: customer.gender,
      job: customer.job,
      address: customer.address,
      mobile: customer.mobile.slice(3),
      birthdate: customer.birthdate,
      company_id: customer.company_id,
      insnumber: customer.insnumber,
      category: customer.category
    });
    var cr = axios.get(Common.baseApiUrl + "getcompanylist");
    axios.all([cr]).then(function (response) {
      var crResponse = response[0];
      if (crResponse.data.status == 200) {
        setCompanies(crResponse.data.companyList);
        crResponse.data.companyList.forEach(function (c) {
          if (c.company_id == null) setCompanyOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              label: c.label,
              value: c.id
            }]);
          });else setCompanyOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              label: c.company == null ? "" : c.company.label + "-" + c.label,
              value: c.id
            }]);
          });
        });
      }
    })["catch"](function (error) {});
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [errorMessage.length != 0 && /*#__PURE__*/_jsx(Alert, {
      message: errorMessage,
      type: "error",
      showIcon: true
    }), successMessage.length != 0 && /*#__PURE__*/_jsx(Alert, {
      message: successMessage,
      type: "success",
      showIcon: true
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Form, {
      layout: "vertical",
      onFinish: onFinish,
      form: form,
      size: "small",
      children: [/*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "firstname",
            label: "Pr\xE9nom",
            rules: [{
              required: true,
              message: 'Ce champs est obligatoire'
            }],
            children: /*#__PURE__*/_jsx(Input, {})
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "lastname",
            label: "Nom",
            rules: [{
              required: true,
              message: 'Ce champs est obligatoire'
            }],
            children: /*#__PURE__*/_jsx(Input, {})
          })
        })]
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "job",
            label: "Profession",
            rules: [{
              required: true,
              message: 'Ce champs est obligatoire'
            }],
            children: /*#__PURE__*/_jsx(Input, {})
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "mobile",
            label: "T\xE9l\xE9phone",
            rules: [{
              required: true,
              message: 'Ce champs est obligatoire'
            }],
            children: /*#__PURE__*/_jsx(Input, {})
          })
        })]
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "birthdate",
            label: "Age",
            rules: [{
              required: true,
              message: 'Ce champs est obligatoire'
            }],
            children: /*#__PURE__*/_jsx(Input, {})
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "gender",
            label: "Genre",
            rules: [{
              required: true,
              message: 'Ce champs est obligatoire'
            }],
            children: /*#__PURE__*/_jsx(Radio.Group, {
              options: genderOptions,
              optionType: "button",
              buttonStyle: "solid"
            })
          })
        })]
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 12,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "category",
            label: "Cat\xE9gorie",
            rules: [{
              required: true,
              message: 'Choisir la catégorie'
            }],
            children: /*#__PURE__*/_jsx(Select, {
              showSearch: true,
              defaultActiveFirstOption: true,
              onChange: onCategorieChanged,
              optionLabelProp: "label",
              optionFilterProp: "label",
              filterOption: function filterOption(input, option) {
                return option.label.toLowerCase().includes(input.toLowerCase());
              },
              options: categoryOptions
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 8,
          md: 12,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "company_id",
            label: "Prise en charge",
            children: /*#__PURE__*/_jsx(Select, {
              onChange: onCompanyChanged,
              disabled: companyDisabled,
              defaultActiveFirstOption: true,
              optionLabelProp: "label",
              optionFilterProp: "label",
              filterOption: function filterOption(input, option) {
                return option.label.toLowerCase().includes(input.toLowerCase());
              },
              showSearch: true,
              options: companyOptions
            })
          })
        })]
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "insnumber",
            label: "ID assur\xE9",
            children: /*#__PURE__*/_jsx(Input, {
              disabled: insDisabled
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            label: "Adresse",
            name: "address",
            children: /*#__PURE__*/_jsx(Input, {})
          })
        })]
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "submit",
        children: /*#__PURE__*/_jsx(Button, {
          loading: isFormLoading,
          htmlType: "submit",
          type: "primary",
          children: /*#__PURE__*/_jsx("b", {
            children: "ENREGISTRER"
          })
        })
      })]
    })]
  });
};
export default EditCustomer;